import { IDateRange } from "libraries/service/resources/model/search/IDateRange";
import { ITextCode } from "libraries/service/resources/model/search/ITextCode";


export enum BookingSearchParametersShortName {
    text = 't',
    code = 'r',
    agency = 'ai',
    agent = 'at',
    pendingValueMin = 'pvmin',
    pendingValueMax = 'pvmax',
    pendingPercentageMin = 'ppmin',
    pendingPercentageMax = 'ppmax',
    paidValueMin = 'pavmin',
    paidValueMax = 'pavmax',
    paidPercentageMin = 'papmin',
    paidPercentageMax = 'papmax',
    dueValueMin = 'dvmin',
    dueValueMax = 'dvmax',
    duePercentageMin = 'dpmin',
    duePercentageMax = 'dpmax',
    xStatus = 's',
    xType = 'xt',
    midOffice = 'mo',
    seatStatus = 'ss',
    person = 'p',
    hasMembershipCard = 'hmc',
    host = 'h',
    type = 'ty',
    issueStatus = 'is',
    retentionReason = 'rtr',
    sectorSeatStatus = 'sss',
    pricingRate = 'pxr',
    pricingXState = 'pxs',
    pricingFarebasis = 'pf',
    documentTicket = 'dt',
    serviceCode = 'svc',
    serviceXStatus = 'sxs',
    hasSeatAssignment = 'hsa',
    system = 'sys',
    systemAgency = 'sag',
    from = 'f',
    to = 'to',
    carrier = 'c',
    sectorMatchAll = 'sma',
    sectorCarrier = 'sc',
    sectorOperatingCarrier = 'soc',
    sectorFlightNumber = 'sfn',
    sectorFrom = 'sf',
    sectorTo = 'st',
    location = 'l',
    whenCreated = 'dc',
    whenAgencyBookingCreated = 'dabc',
    whenLastUpdated = 'dlu',
    whenIssued = 'di',
    whenToIssue = 'dti',
    begin = 'db',
    end = 'de',
    whenTravelReallyBegins = 'dwtrb',
    sectorBeginDate = 'sbd',
    sectorArrivalDate = 'sad',
    whenOptionDrops = 'od',
    whenRetentionEnds = 'rte',
    remarkText = 'rt',
    remarkRemark = 'rr',
    remarkNote = 'rn',
    remarkInvoicing = 'ri',
    remarkOsi = 'ro',
    remarkVendorAlert= 'rva',
    first = 'first',
    nbrecord = 'nbrecord',
    form = 'form',
    serviceCodes = 'sv',
    eligibilityStatuses = 'eb',
    operationStatuses = 'op',
    whenExecutedOperation = 'eo',

    ticketMatchAll = 'tma',
    ticketSectorFrom = 'tsf',
    ticketSectorTo = 'tst',
    ticketStatus = 'ts',
    ticketNativeStatus = 'tns',
    ticketSectorBeginDate = 'tsbd',
    ticketSectorCarrier = 'tsc',
    ticketFlightNumber = 'tfn',

    placesToStay = 'ptc',
    propertyName = 'pn',
    propertyReference = 'pr',
    stayBeginDate = 'stbd',
    stayArrivalDate = 'stad',
    hasFareOptimisation = 'hfo',
    actionForFareOptimisation = 'affo',
    savingMin = 'smfo',
    impactOnFareType = 'ioft',
    impactOnLuggage = 'iol',
    qualityCheck = 'qc'
}

export enum BookingSearchParameters {
    text = 'text',
    code = 'code',
    agency = 'agency',
    agent = 'agent',
    person = 'person',
    hasMembershipCard = 'hasMembershipCard',
    host = 'host',
    type = 'type',
    xStatus = 'xStatus',
    xType = 'xType',
    midOffice = 'midOffice',
    seatStatus = 'seatStatus',
    issueStatus = 'issueStatus',
    retentionReason = 'retentionReason',
    from = 'from',
    to = 'to',
    carrier = 'carrier',
    whenCreated = 'whenCreated',
    whenAgencyBookingCreated = 'whenAgencyBookingCreated',
    whenLastUpdated = 'whenLastUpdated',
    whenIssued = 'whenIssued',
    whenToIssue = 'whenToIssue',
    whenOptionDrops = 'whenOptionDrops',
    whenRetentionEnds = 'whenRetentionEnds',
    begin = 'begin',
    end = 'end',
    whenTravelReallyBegins = 'whenTravelReallyBegins',
    nbrecord = 'nbrecord',
    first = 'first',
    sectorMatchAll = 'sectorMatchAll',
    sectorFrom = 'sectorFrom',
    sectorTo = 'sectorTo',
    sectorSeatStatus = 'sectorSeatStatus',
    sectorBeginDate = 'sectorBeginDate',
    sectorArrivalDate = 'sectorArrivalDate',
    sectorCarrier = 'sectorCarrier',
    sectorOperatingCarrier = 'sectorOperatingCarrier',
    sectorFlightNumber = 'sectorFlightNumber',
    location = 'location',
    documentTicket = 'documentTicket',
    pricingRate = 'pricingRate',
    pricingXState = 'pricingXState',
    pricingFarebasis = 'pricingFarebasis',
    serviceCode = 'serviceCode',
    serviceXStatus = 'serviceXStatus',
    hasSeatAssignment = 'hasSeatAssignment',
    form = 'form',
    remarkText = 'remarkText',
    remarkRemark = 'remarkRemark',
    remarkNote = 'remarkNote',
    remarkInvoicing = 'remarkInvoicing',
    remarkOsi = 'remarkOsi',
    remarkVendorAlert = 'remarkVendorAlert',
    system = 'system',
    systemAgency = 'systemAgency',
    serviceCodes = 'serviceCodes',
    eligibilityStatuses = 'eligibilityStatuses',
    operationStatuses = 'operationStatuses',
    whenExecutedOperation = 'whenExecutedOperation',
    afidiumServices = 'afidiumServices',

    ticketMatchAll = 'ticketMatchAll',
    ticketSectorFrom = 'ticketSectorFrom',
    ticketSectorTo = 'ticketSectorTo',
    ticketStatus = 'ticketStatus',
    ticketNativeStatus = 'ticketNativeStatus',
    ticketSectorBeginDate = 'ticketSectorBeginDate',
    ticketSectorCarrier = 'ticketSectorCarrier',
    ticketFlightNumber = 'ticketFlightNumber',
    pendingValueMin = 'pendingValueMin',
    pendingPercentageMin = 'pendingPercentageMin',
    pendingValueMax = 'pendingValueMax',
    pendingPercentageMax = 'pendingPercentageMax',
    paidValueMin = 'paidValueMin',
    paidPercentageMin = 'paidPercentageMin',
    paidValueMax = 'paidValueMax',
    paidPercentageMax = 'paidPercentageMax',
    dueValueMin = 'dueValueMin',
    duePercentageMin = 'duePercentageMin',
    dueValueMax = 'dueValueMax',
    duePercentageMax = 'duePercentageMax',

    placesToStay = 'placesToStay',
    propertyName = 'propertyName',
    propertyReference = 'propertyReference',
    stayBeginDate = 'stayBeginDate',
    stayArrivalDate = 'stayArrivalDate',
    hasFareOptimisation = 'hasFareOptimisation',
    actionForFareOptimisation = 'actionForFareOptimisation',
    savingMin = 'savingMin',
    impactOnFareType = 'impactOnFareType',
    impactOnLuggage = 'impactOnLuggage',
    qualityCheck = 'qualityCheck',
}

export interface IBookingSearchParameters {
    [BookingSearchParameters.text]?: string[];
    [BookingSearchParameters.code]?: string[];
    [BookingSearchParameters.agency]?: string[];
    [BookingSearchParameters.agent]?: string[];
    [BookingSearchParameters.person]?: string[];
    [BookingSearchParameters.hasMembershipCard]?: string[];
    [BookingSearchParameters.host]?: string[];
    [BookingSearchParameters.xStatus]?: string[];
    [BookingSearchParameters.midOffice]?: string[];
    [BookingSearchParameters.from]?: ITextCode;
    [BookingSearchParameters.to]?: ITextCode;
    [BookingSearchParameters.carrier]?: ITextCode;
    [BookingSearchParameters.whenCreated]?: IDateRange;
    [BookingSearchParameters.whenAgencyBookingCreated]?: IDateRange;
    [BookingSearchParameters.begin]?: IDateRange;
    [BookingSearchParameters.end]?: IDateRange;
    [BookingSearchParameters.whenTravelReallyBegins]?: IDateRange;
    [BookingSearchParameters.nbrecord]?: number;
    [BookingSearchParameters.first]?: number;
    [BookingSearchParameters.seatStatus]?: string[];
    [BookingSearchParameters.sectorMatchAll]?: boolean;
    [BookingSearchParameters.sectorFrom]?: ITextCode;
    [BookingSearchParameters.sectorTo]?: ITextCode;
    [BookingSearchParameters.sectorSeatStatus]?: string[];
    [BookingSearchParameters.sectorBeginDate]?: IDateRange;
    [BookingSearchParameters.sectorArrivalDate]?: IDateRange;
    [BookingSearchParameters.sectorCarrier]?: ITextCode;
    [BookingSearchParameters.sectorOperatingCarrier]?: ITextCode;
    [BookingSearchParameters.sectorFlightNumber]?: string[];
    [BookingSearchParameters.location]?: ITextCode;
    [BookingSearchParameters.documentTicket]?: string[];
    [BookingSearchParameters.pricingRate]?: string[];
    [BookingSearchParameters.pricingXState]?: string[];
    [BookingSearchParameters.pricingFarebasis]?: string[];
    [BookingSearchParameters.serviceCode]?: string[];
    [BookingSearchParameters.serviceXStatus]?: string[];
    [BookingSearchParameters.hasSeatAssignment]?: string[];
    [BookingSearchParameters.retentionReason]?: string[];
    [BookingSearchParameters.whenRetentionEnds]?: IDateRange;
    [BookingSearchParameters.remarkText]?: string[];
    [BookingSearchParameters.remarkRemark]?: string[];
    [BookingSearchParameters.remarkNote]?: string[];
    [BookingSearchParameters.remarkInvoicing]?: string[];
    [BookingSearchParameters.remarkOsi]?: string[];
    [BookingSearchParameters.remarkVendorAlert]?: string[];
    [BookingSearchParameters.form]?: boolean;

    [BookingSearchParameters.ticketMatchAll]?: boolean;
    [BookingSearchParameters.ticketSectorFrom]?: ITextCode;
    [BookingSearchParameters.ticketSectorTo]?: ITextCode;
    [BookingSearchParameters.ticketSectorBeginDate]?: IDateRange;
    [BookingSearchParameters.ticketStatus]?: string[];
    [BookingSearchParameters.ticketNativeStatus]?: string[];
    [BookingSearchParameters.ticketFlightNumber]?: string[];
    [BookingSearchParameters.ticketSectorCarrier]?: ITextCode;

    [BookingSearchParameters.pendingValueMin]?: number;
    [BookingSearchParameters.pendingValueMax]?: number;
    [BookingSearchParameters.pendingPercentageMin]?: number;
    [BookingSearchParameters.pendingPercentageMax]?: number;

    [BookingSearchParameters.paidValueMin]?: number;
    [BookingSearchParameters.paidValueMax]?: number;
    [BookingSearchParameters.paidPercentageMin]?: number;
    [BookingSearchParameters.paidPercentageMax]?: number;
    [BookingSearchParameters.dueValueMin]?: number;
    [BookingSearchParameters.dueValueMax]?: number;
    [BookingSearchParameters.duePercentageMin]?: number;
    [BookingSearchParameters.duePercentageMax]?: number;

    [BookingSearchParameters.placesToStay]?: string[];
    [BookingSearchParameters.propertyName]?: string[];
    [BookingSearchParameters.propertyReference]?: string[];
    [BookingSearchParameters.stayBeginDate]?: IDateRange;
    [BookingSearchParameters.stayArrivalDate]?: IDateRange;
    [BookingSearchParameters.hasFareOptimisation]?: boolean;
    [BookingSearchParameters.actionForFareOptimisation]?: string[];
    [BookingSearchParameters.savingMin]?: number;
    [BookingSearchParameters.impactOnFareType]?: string[];
    [BookingSearchParameters.impactOnLuggage]?: string[];

    [BookingSearchParameters.qualityCheck]?: string[];
}

export interface IBookingSearchParametersURLCompressed {
    search: string;
}

export interface IBookingSearchParametersURL {
    [BookingSearchParametersShortName.text]: string;
    [BookingSearchParametersShortName.code]: string;
    [BookingSearchParametersShortName.agency]: string;
    [BookingSearchParametersShortName.agent]: string;
    [BookingSearchParametersShortName.pendingPercentageMax]: string;
    [BookingSearchParametersShortName.pendingPercentageMin]: string;
    [BookingSearchParametersShortName.pendingValueMin]: string;
    [BookingSearchParametersShortName.pendingValueMax]: string;
    [BookingSearchParametersShortName.paidPercentageMax]: string;
    [BookingSearchParametersShortName.paidPercentageMin]: string;
    [BookingSearchParametersShortName.paidValueMin]: string;
    [BookingSearchParametersShortName.paidValueMax]: string;
    [BookingSearchParametersShortName.duePercentageMax]: string;
    [BookingSearchParametersShortName.duePercentageMin]: string;
    [BookingSearchParametersShortName.dueValueMin]: string;
    [BookingSearchParametersShortName.dueValueMax]: string;
    [BookingSearchParametersShortName.xStatus]: string;
    [BookingSearchParametersShortName.xType]: string;
    [BookingSearchParametersShortName.midOffice]: string;
    [BookingSearchParametersShortName.seatStatus]: string;

    [BookingSearchParametersShortName.person]: string;
    [BookingSearchParametersShortName.hasMembershipCard]: string;

    [BookingSearchParametersShortName.host]: string;
    [BookingSearchParametersShortName.issueStatus]: string;
    [BookingSearchParametersShortName.retentionReason]: string;
    [BookingSearchParametersShortName.sectorSeatStatus]: string;
    [BookingSearchParametersShortName.pricingRate]: string;
    [BookingSearchParametersShortName.pricingXState]: string;
    [BookingSearchParametersShortName.pricingFarebasis]: string;
    [BookingSearchParametersShortName.documentTicket]: string;
    [BookingSearchParametersShortName.serviceCode]: string;
    [BookingSearchParametersShortName.serviceXStatus]: string;
    [BookingSearchParametersShortName.hasSeatAssignment]: string;
    [BookingSearchParametersShortName.system]: string;
    [BookingSearchParametersShortName.systemAgency]: string;
    [BookingSearchParametersShortName.from]: string;
    [BookingSearchParametersShortName.to]: string;
    [BookingSearchParametersShortName.carrier]: string;
    [BookingSearchParametersShortName.sectorMatchAll]: string;
    [BookingSearchParametersShortName.sectorCarrier]: string;
    [BookingSearchParametersShortName.sectorOperatingCarrier]: string;
    [BookingSearchParametersShortName.sectorFlightNumber]: string;
    [BookingSearchParametersShortName.sectorFrom]: string;
    [BookingSearchParametersShortName.sectorTo]: string;
    [BookingSearchParametersShortName.location]: string;
    [BookingSearchParametersShortName.whenCreated]: string;
    [BookingSearchParametersShortName.whenAgencyBookingCreated]: string;
    [BookingSearchParametersShortName.whenLastUpdated]: string;
    [BookingSearchParametersShortName.whenIssued]: string;
    [BookingSearchParametersShortName.whenToIssue]: string;
    [BookingSearchParametersShortName.begin]: string;
    [BookingSearchParametersShortName.end]: string;
    [BookingSearchParametersShortName.whenTravelReallyBegins]: string;
    [BookingSearchParametersShortName.sectorBeginDate]: string;
    [BookingSearchParametersShortName.sectorArrivalDate]: string;
    [BookingSearchParametersShortName.whenOptionDrops]: string;
    [BookingSearchParametersShortName.whenRetentionEnds]: string;
    [BookingSearchParametersShortName.remarkText]: string;
    [BookingSearchParametersShortName.remarkRemark]: string;
    [BookingSearchParametersShortName.remarkNote]: string;
    [BookingSearchParametersShortName.remarkInvoicing]: string;
    [BookingSearchParametersShortName.remarkOsi]: string;
    [BookingSearchParametersShortName.remarkVendorAlert]: string;
    [BookingSearchParametersShortName.first]: number;
    [BookingSearchParametersShortName.nbrecord]: number;
    [BookingSearchParametersShortName.form]: boolean;

    [BookingSearchParametersShortName.ticketStatus]: string;
    [BookingSearchParametersShortName.ticketNativeStatus]: string;
    [BookingSearchParametersShortName.ticketFlightNumber]: string;
    [BookingSearchParametersShortName.ticketSectorCarrier]: string;
    [BookingSearchParametersShortName.ticketSectorBeginDate]: string;
    [BookingSearchParametersShortName.ticketSectorTo]: string;
    [BookingSearchParametersShortName.ticketSectorFrom]: string;
    [BookingSearchParametersShortName.ticketMatchAll]: string;

    [BookingSearchParametersShortName.placesToStay]: string;
    [BookingSearchParametersShortName.propertyName]: string;
    [BookingSearchParametersShortName.propertyReference]: string;
    [BookingSearchParametersShortName.stayBeginDate]: string;
    [BookingSearchParametersShortName.stayArrivalDate]: string;
    [BookingSearchParametersShortName.hasFareOptimisation]: string;
    [BookingSearchParametersShortName.actionForFareOptimisation]: string;
    [BookingSearchParametersShortName.savingMin]: string;
    [BookingSearchParameters.impactOnFareType]?: string;
    [BookingSearchParameters.impactOnLuggage]?: string;

    [BookingSearchParametersShortName.qualityCheck]: string;
}
